export default __webpack_public_path__ + "static/media/sustentabilidade3.62d4f3c0.png";